import React from 'react';
import { isTrustedImageUrl, resolveApiAssetUrl } from 'src/lib/utils/urls';
import { UntrustedImageLink } from 'src/components/ui/GuardedImage';

export interface MarkdownImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  onImageClick?: (url: string, alt?: string) => void;
  node?: unknown;
}

export function MarkdownImage({ src, alt, onImageClick, node: _node, ...props }: MarkdownImageProps) {
  if (!src) return null;
  const resolvedSrc = resolveApiAssetUrl(src);
  if (!isTrustedImageUrl(resolvedSrc)) return <UntrustedImageLink url={resolvedSrc} />;

  const handleClick = () => {
    if (onImageClick) {
      onImageClick(resolvedSrc, alt);
    } else {
      window.open(resolvedSrc, '_blank', 'noopener,noreferrer');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLImageElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <img
      src={resolvedSrc}
      alt={alt || ''}
      aria-label={alt || props.title || 'Open image'}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className="my-3 block max-h-[440px] max-w-full rounded-lg border border-border-default object-contain cursor-pointer hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-border-active"
      loading="lazy"
      {...props}
    />
  );
}
